export const FETCH_DECKS_REQUEST = "fetch/decks/request";
export const FETCH_DECKS_SUCCESS = "fetch/decks/success";
export const FETCH_DECKS_FAILURE = "fetch/decks/failure";
export const FETCH_DECK_REQUEST = "fetch/deck/request";
export const FETCH_DECK_SUCCESS = "fetch/deck/success";
export const FETCH_DECK_FAILURE = "fetch/deck/failure";
export const UPDATE_DECK_REQUEST = "update/deck/request";
export const UPDATE_DECK_SUCCESS = "update/deck/success";
export const UPDATE_DECK_FAILURE = "update/deck/failure";
export const CREATE_DECK_REQUEST = "create/deck/request";
export const CREATE_DECK_SUCCESS = "create/deck/success";
export const CREATE_DECK_FAILURE = "create/deck/failure";
export const DELETE_DECK_REQUEST = "delete/deck/request";
export const DELETE_DECK_SUCCESS = "delete/deck/success";
export const DELETE_DECK_FAILURE = "delete/deck/failure";
export const DUPLICATE_DECK_REQUEST = "duplicate/deck/request";
export const DUPLICATE_DECK_SUCCESS = "duplicate/deck/success";
export const DUPLICATE_DECK_FAILURE = "duplicate/deck/failure";
export const FETCH_CARD_REQUEST = "fetch/card/request";
export const FETCH_CARD_SUCCESS = "fetch/card/success";
export const FETCH_CARD_FAILURE = "fetch/card/failure";
export const UPDATE_CARD_REQUEST = "update/card/request";
export const UPDATE_CARD_SUCCESS = "update/card/success";
export const UPDATE_CARD_FAILURE = "update/card/failure";
export const CREATE_CARD_REQUEST = "create/card/request";
export const CREATE_CARD_SUCCESS = "create/card/success";
export const CREATE_CARD_FAILURE = "create/card/failure";
export const DELETE_CARD_REQUEST = "delete/card/request";
export const DELETE_CARD_SUCCESS = "delete/card/success";
export const DELETE_CARD_FAILURE = "delete/card/failure";
export const CREATE_PROFICIENCY_REQUEST = "create/proficiency/request";
export const CREATE_PROFICIENCY_SUCCESS = "create/proficiency/success";
export const CREATE_PROFICIENCY_FAILURE = "create/proficiency/failure";
